import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-custom-graph-empty',
    templateUrl: './custom-graph-empty.component.html',
    styleUrls: ['./custom-graph-empty.component.scss'],
    standalone: false
})
export class CustomGraphEmptyComponent {
    @Input() selected!: boolean;
}
